/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../../../common/header/Header";
import Footer from "../../../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      ul: "ul",
      li: "li"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Modulabs Subprocessors"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Modulabs Subprocessors"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsxs(_components.p, {
                    children: ["We use third party subprocessors, such as cloud computing providers and customer support\nsoftware, to run Basecamp (the service). We establish GDPR-compliant data processing\nagreements with each subprocessor, extending ", _jsx(_components.a, {
                      href: "../regulations/index.md",
                      children: "GDPR safeguards"
                    }), "\neverywhere personal data is processed."]
                  }), _jsx(_components.p, {
                    children: "The following is a list of personal data subprocessors we use. These subprocessors are all\nlocated in the United States:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsxs(_components.li, {
                      children: [_jsx(_components.a, {
                        href: "https://stripe.com/guides/general-data-protection-regulation",
                        children: "Stripe"
                      }), ". Payment\ntransfer service."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.a, {
                        href: "https://commerce.coinbase.com/legal/privacy-policy/",
                        children: "Coinbase"
                      }), ". Payment\ntransfer service."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.a, {
                        href: "https://cloud.google.com/security/gdpr/resource-center/",
                        children: "Google Cloud Platform"
                      }), ". Cloud\nservices provider."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.a, {
                        href: "https://blog.sentry.io/2018/03/14/gdpr-sentry-and-you",
                        children: "Sentry"
                      }), ". Error reporting software."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.a, {
                        href: "https://auth0.com/docs/secure/data-privacy-and-compliance/gdpr",
                        children: "Auth0"
                      }), ". Cloud\nservices provider."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.a, {
                        href: "https://www.netlify.com/gdpr-ccpa/",
                        children: "Netlify"
                      }), ". Cloud\nservices provider."]
                    }), "\n"]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
